import { SubscriptionCenterTopicsRoute } from './-subscription-center-routes';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/')({
  component: TopicsRedirect,
});

function TopicsRedirect() {
  const { workspaceId } = Route.useParams();
  return <SubscriptionCenterTopicsRoute workspaceId={workspaceId} />;
}
